import { Typography } from '@pwskills/rachnaui';
import React from 'react';

interface IProps {
  upperText?: string;
  lowerText?: string;
  isSeo?: boolean;
}

const SectionTitle = ({ upperText, lowerText, isSeo }: IProps) => {
  return (
    <div className="flex flex-col gap-1 large:!gap-4">
      <div>
        <Typography
          component={isSeo ? 'h1' : 'h2'}
          variant="bold"
          className="text-[#B5BBC5] font-inter text-[24px] medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
        >
          {upperText}
        </Typography>
      </div>
      <div>
        <Typography
          component={isSeo ? 'h1' : 'h2'}
          variant="bold"
          className="text-gray-850 font-inter text-[24px] medium:!text-[32px] large:!text-[48px] leading-[2rem] medium:!leading-[44px]"
        >
          {lowerText}
        </Typography>
      </div>
    </div>
  );
};

export default SectionTitle;
